/**
 * You don't need to change this file :)
 */

import { System, StaticBundleResolver } from 'front-system';
import topology from './generated';
import { BundleName, BundlesModules } from './generated/bundles.d';
import { ModuleName, ModulesExport } from './generated/modules.d';

// tslint:disable-next-line:no-unused-expression
new System<BundleName, ModuleName, BundlesModules, ModulesExport>({
  bundleResolver: new StaticBundleResolver('/asset-manifest.json'),
  topology,
});



// WEBPACK FOOTER //
// ./src/index.tsx